/**
 * Nova Proactive Reach-Out — Message Templates
 *
 * message_id -> Nova message string. Tokens: {first_name}, {week_number},
 * {child_name}, {child_age}, {city}. Replace with exact PRD copy as needed.
 */

export const NOVA_MESSAGES = {
  // ── Cycle (First Chapter) ───────────────────────────────────
  cycle_period_expected:
    '{first_name}, your period may be starting soon based on your cycle. How are you feeling? I’m here if you want to talk or track symptoms.',
  cycle_mood_checkin:
    'I noticed your mood has been lower lately, {first_name}. You’re not alone. Want to check in? I’m here whenever you’re ready.',
  cycle_one_month:
    'You’ve been tracking with Nova for a month, {first_name}. Proud of you for showing up. What’s been helpful so far?',

  // ── IVF ─────────────────────────────────────────────────────
  ivf_retrieval_tomorrow:
    '{first_name}, retrieval is tomorrow. I have a prep note ready for you — what to bring, what to expect, and a thread from others who did this last week. You’ve got this.',
  ivf_two_week_wait:
    'You’re in the two-week wait, {first_name}. It’s one of the hardest parts. I’m here if you need to vent, ask questions, or just not feel alone.',
  ivf_stims_week_two:
    'Week two of stims — you’re doing great, {first_name}. How are you feeling? Any questions before retrieval?',

  // ── TTC ─────────────────────────────────────────────────────
  ttc_fertile_window_start:
    '{first_name}, your fertile window is starting today. I’ve got your tracking info — anything you want to try differently this cycle?',
  ttc_ovulation_checkin:
    'Right around ovulation, {first_name}. How are you doing? I’m here if you have questions or just want to talk.',
  ttc_three_months:
    'You’ve been tracking with Nova for three months, {first_name}. That takes dedication. Want to review your patterns or talk about next steps?',

  // ── Pregnancy ───────────────────────────────────────────────
  pregnancy_12_week:
    'You’re at 12 weeks, {first_name}. A big milestone. How are you feeling? I’ve got info on what to expect and when to call your OB.',
  pregnancy_anatomy_scan:
    'Anatomy scan territory, {first_name} — around week {week_number}. Exciting and sometimes nerve-wracking. I’m here if you want to prep or debrief.',
  pregnancy_full_term:
    'You’re full term, {first_name}. 37 weeks is huge. I’ve got birth-prep reminders and support whenever you need it.',

  // ── Postpartum ──────────────────────────────────────────────
  postpartum_one_week:
    '{first_name}, one week with {child_name}. How are you? Sleep, feeding, mood — I’m here for all of it. No judgment.',
  postpartum_six_weeks:
    'Six weeks in, {first_name}. This is often when reality settles. How are you really doing? I’ve got resources if you need them.',
  postpartum_three_months:
    '{child_name} is three months old, {first_name}. A lot changes in this window. How’s your family? I’m here for questions and support.',

  // ── Menopause ───────────────────────────────────────────────
  menopause_one_month:
    'You’ve been tracking menopause symptoms for a month, {first_name}. Patterns can take time to show. I’m here with info and support.',
  menopause_hot_flash_pattern:
    'I noticed more hot flash logs lately, {first_name}. Want to talk about what helps — or connect with others who get it?',
  menopause_seasonal_checkin:
    'Checking in, {first_name}. Heat or seasonal changes can affect symptoms. How are you doing?',
};

/**
 * Resolve message template with token replacement.
 * @param {string} messageId
 * @param {Object} tokens - { first_name, week_number, child_name, child_age, city }
 * @returns {string}
 */
export function resolveMessage(messageId, tokens = {}) {
  const template = NOVA_MESSAGES[messageId];
  if (!template) return '';
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    const val = tokens[key];
    return val != null ? String(val) : '';
  });
}
